/**
 * @file crudActions.js
 * @location src/store/reducers/taskActions/crudActions.js
 * @role 업무 CRUD 액션 barrel — lifecycle + trash 결합
 *
 *  세부 액션 정의는 ./crud/lifecycle.js (생성·편집·토글) / ./crud/trash.js (휴지통·자동 cleanup) 참조.
 */
import { lifecycleActions } from './crud/lifecycle.js';
import { trashActions }     from './crud/trash.js';

export const crudActions = { ...lifecycleActions, ...trashActions };
